import type FacebookPage from "@/managers/data/facebook/facebookPage"
import Accounts from "@/managers/facebook/accounts"
import {when} from "@/store/store"
import {firstOrNull} from "@/utility/structure/array"
import Publishers from "@/managers/organization/publishers"

class Pages {
	public get canGet(): boolean {
		return Accounts.canLoad
	}

	public getImage(id: string): string {
		return `https://graph.facebook.com/${id}/picture?type=normal`
	}

	public getPage(id: string): Promise<FacebookPage> {
		return this.getPagePublisherId(id, Publishers.facebookId)
	}

	public getPageByInstagram(id: string): Promise<FacebookPage> {
		return this.getPagePublisherId(id, Publishers.instagramId)
	}

	public async getPagePublisherId(id: string, publisherId: number): Promise<FacebookPage> {
		await when(() => Accounts.isReady || !Accounts.isUpdating)

		if (Accounts.isReady) {
			const account = firstOrNull(Accounts.list!, a => Accounts.isAccount(a, id, publisherId))
			if (account !== null)
				return account
		}

		throw new Error("Failed to get page")
	}
}

export default new Pages()
